import React from "react";
import "./styles.css";

const dummyClients = [
  {
    name: "Acme Corp",
    logo: "https://upload.wikimedia.org/wikipedia/commons/4/4a/Logo_2013_Google.png",
  },
  {
    name: "Globex",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
  },
  {
    name: "Initech",
    logo: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
  },
  {
    name: "Umbrella",
    logo: "https://upload.wikimedia.org/wikipedia/commons/1/17/Google-flutter-logo.png",
  },
  {
    name: "Stark Industries",
    logo: "https://upload.wikimedia.org/wikipedia/commons/1/1b/IBM_logo.svg",
  },
  {
    name: "Wayne Enterprises",
    logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg",
  },
  {
    name: "Hooli",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg",
  },
  {
    name: "Wonka",
    logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/SAP_2011_logo.svg",
  },
];

const ClientsCarousel = () => (
  <section className="clients-carousel-section">
    <div className="clients-carousel-track">
      {[...dummyClients, ...dummyClients].map((client, i) => (
        <div className="carousel-client-logo" key={i}>
          <img src={client.logo} alt={client.name} />
        </div>
      ))}
    </div>
  </section>
);

export default ClientsCarousel;
